// Upload file constants
export const UPLOAD_ACCEPT = {
  IMAGE: {
    MIME_TYPES: "image/jpeg, image/jpg, image/png, image/gif, image/webp",
    EXTENSIONS: [".jpeg", ".jpg", ".png", ".gif", ".webp"],
    DROPZONE_FORMAT: {
      "image/*": [".jpeg", ".jpg", ".png", ".gif", ".webp"],
    },
  },
} as const;

export const UPLOAD_MAX_SIZE = {
  IMAGE: 5242880, // 5MB
} as const;
